import React, { useEffect } from "react";
import { Tabs } from "antd";
import { useTranslation } from "react-i18next";
import { getDaysOfWeek } from "../../../../../services/utils";
import CollapsibleSection from "./CollapsibleSection";
import AudienceProviderNote from "./AudienceProviderNote";
import AudienceBarChart from "./AudienceBarChart";

const { TabPane } = Tabs;

const ScreenAudienceSection = (props) => {
  const { t } = useTranslation();
  const {
    display,
    audienceDaysOfWeek,
    audienceHoursOfDay,
    audienceQualitative,
    getAudienceDaysOfWeekRequest,
    getAudienceHoursOfDayRequest,
    getAudienceQualitativeRequest,
  } = props;

  const displayId = display && display.id;

  useEffect(() => {
    if (displayId) {
      getAudienceDaysOfWeekRequest(displayId);
      getAudienceHoursOfDayRequest({ display_ids: displayId, days: [] });
      getAudienceQualitativeRequest(displayId);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [displayId]);

  const dayLabels = getDaysOfWeek(t).map((d) => d.label);
  const dayValues =
    audienceDaysOfWeek && audienceDaysOfWeek.data
      ? audienceDaysOfWeek.data.map((d) => d.audience)
      : [];

  const hourLabels = Array.from({ length: 24 }, (_, i) => `${i}:00`);
  const hourValues =
    audienceHoursOfDay && audienceHoursOfDay.data
      ? audienceHoursOfDay.data.map((h) => h.audience)
      : [];

  const hasQualitative =
    audienceQualitative && audienceQualitative.data && audienceQualitative.data.length > 0;

  return (
    <CollapsibleSection title={t("Audience")}>
      <Tabs defaultActiveKey="1">
        <TabPane tab={t("General")} key="1">
          <AudienceProviderNote display={display} />
          <div className="audienceChart__title">{t("Average audience by days of the week")}</div>
          <AudienceBarChart labels={dayLabels} values={dayValues} axisTitle={t("Audience Average")} />
        </TabPane>

        <TabPane tab={t("By day of week")} key="2">
          <AudienceProviderNote display={display} />
          <div className="audienceChart__title">{t("Average audience by hours")}</div>
          <AudienceBarChart labels={hourLabels} values={hourValues} axisTitle={t("Audience Average")} />
        </TabPane>

        <TabPane tab={t("Qualitative")} key="3">
          <AudienceProviderNote display={display} view="qualitative" />
          {hasQualitative ? (
            <div className="audienceQualitative">
              {audienceQualitative.data.map((attr, i) => (
                <div key={i} className="audienceQualitative__row">
                  <span className="audienceQualitative__label">{attr.label || attr.name}</span>
                  <span className="audienceQualitative__value">{attr.value}</span>
                </div>
              ))}
            </div>
          ) : (
            <div className="audienceEmpty">{t("There is no audience data available")}</div>
          )}
        </TabPane>
      </Tabs>
    </CollapsibleSection>
  );
};

export default ScreenAudienceSection;
